export default "__VITE_ASSET__0tVZcSEv__"